export default "__VITE_ASSET__CNY67_NA__"